import React from 'react'
import '../styles.css'

const ObjetivesCard = ({ text, img }: { text: string, img: string }) => {
    return (
        <div className='h-[13.5rem] md:h-full w-full bg-brand-green-15 rounded-sm'>
            <div className='p-8 flex items-center justify-start flex-col gap-2 h-full'>
                <img src={img} className='w-[4.5rem] h-[4.5rem] md:w-max md:h-max' alt='objetivos' />
                <p className='text-tmedium text-primary-100 w-full text-center'>{text}</p>
            </div>
        </div>
    )
}

export default ObjetivesCard